import { pluralizePl } from '@/app/app/_utils/pluralizePl'
import type { CollectionAccessPreviewItem } from './types'

const BADGE_HORIZONTAL_PADDING_PX = 12
const BADGE_CHAR_WIDTH_PX = 7

const USER_AVATAR_WIDTH_PX = 24
const USER_GAP_PX = 12
const USER_CHAR_WIDTH_PX = 7

const ITEM_GAP_PX = 12
const MAX_ITEM_WIDTH_PX = 320

// Inner width of CollectionGridCard in the narrowest manage-grid column (lg: 3 cols).
const ROW_WIDTH_PX = 280

function estimateAccessPreviewItemWidth(item: CollectionAccessPreviewItem): number {
  if (item.kind === 'role') {
    return Math.min(
      MAX_ITEM_WIDTH_PX,
      BADGE_HORIZONTAL_PADDING_PX + item.role.role.length * BADGE_CHAR_WIDTH_PX
    )
  }

  const label = item.user.fullName ?? item.user.email

  return Math.min(
    MAX_ITEM_WIDTH_PX,
    USER_AVATAR_WIDTH_PX + USER_GAP_PX + label.length * USER_CHAR_WIDTH_PX
  )
}

function estimateCombinedWidth(items: CollectionAccessPreviewItem[]): number {
  return items.reduce(
    (totalWidth, item, index) =>
      totalWidth + estimateAccessPreviewItemWidth(item) + (index > 0 ? ITEM_GAP_PX : 0),
    0
  )
}

function estimateMoreLabelWidth(hiddenCount: number): number {
  const suffix = pluralizePl(hiddenCount, {
    one: 'inna',
    few: 'inne',
    many: 'innych'
  })

  return 16 + String(hiddenCount).length * 7 + suffix.length * 7
}

export function getAccessPreviewVisibleCount(items: CollectionAccessPreviewItem[]): number {
  if (items.length <= 1) {
    return items.length
  }

  const firstTwoWidth = estimateCombinedWidth(items.slice(0, 2))
  const hiddenCountIfTwoVisible = items.length - 2
  const availableWidth =
    hiddenCountIfTwoVisible > 0
      ? ROW_WIDTH_PX - estimateMoreLabelWidth(hiddenCountIfTwoVisible)
      : ROW_WIDTH_PX

  return firstTwoWidth <= availableWidth ? 2 : 1
}
